<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: zh
 * @Date: 2021-11-12 10:46:31
 * @LastEditors: yfw
 * @LastEditTime: 2025-06-26 13:08:07
-->
<template>
  <div class="container">
    <div class="bgoverlay">
      <div class="bg" :style="{'background-image': `url(${require('@/assets/images/cangchubg.jpg')})`}"></div>
    </div>
    <div class="inner-pannel">
      <div class="pannel-content">
        <div class="pannel-content-box maxwidth-lg topPoint">
          <div style="height:55px;"></div>
          <div class="content-page">
            <div class="ani animate__animated animate__fadeInUp">
              <p :class="$i18n.locale=='zh'?'zh-font':'en-font'">{{$t('diversifiedtransportIndex.content')}}</p>
              <div style="height:20px"></div>
              <p class="link " style="color: #ed6d00" @click="goTo('2-1')">{{$t('services.function[1].subName[0]')}}</p>
              <!-- <div style="height:20px"></div> -->
              <p class="link" style="color: #ed6d00" @click="goTo('2-2')">{{$t('services.function[1].subName[1]')}}</p>
              <!-- <div style="height:20px"></div> -->
              <p class="link" style="color: #ed6d00" @click="goTo('2-3')">{{$t('services.function[1].subName[2]')}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default({
  data() {
    return {

    }
  },
  methods: {
    goTo(path) {
      // this.$router.push({path:'/services/diversifiedTransport',query: { index: path}})
      this.$emit('goToDetail', path)
    }
  }
})
</script>

<style scoped>
  .topPoint::after {
      width: 25px;
      height: 25px;
      content: "";
      position: absolute;
      background: #ed6d00;
      border-radius: 50%;
      z-index: 1;
      top: -12.5px;
      right: -12.5px;
  }
  .right-color{
    color: #ed6d00;
  }
  .link{
    cursor:pointer;
    font-family: 'Lato','Microsoft JhengHei';
  }
</style>



// WEBPACK FOOTER //
// src/components/diversifiedtransportIndex/diversifiedtransportIndex.vue